/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import ethereumLogoImage from 'src/assets/chains/1-ethereum.jpg'
import bscLogoImage from 'src/assets/chains/56-binance.jpg'
import polygonLogoImage from 'src/assets/chains/137-polygon.jpg'

import { Chain, ChainId, Token } from '../types/main'
import BSC_TOKENS from './tokens/bsc.json'
import POLYGON_TOKENS from './tokens/polygon.json'

export const APP_NAME = 'The Good Blockchain'

export const CHAIN_MAP: Record<ChainId, Chain> = {
  [ChainId.ETHEREUM]: {
    decimals: 18,
    logoUri: ethereumLogoImage,
    name: 'Ethereum Mainnet',
    symbol: 'ETH'
  },
  [ChainId.BSC]: {
    decimals: 18,
    logoUri: bscLogoImage,
    name: 'Binance Smart Chain',
    symbol: 'BSC'
  },
  [ChainId.POLYGON]: {
    decimals: 18,
    logoUri: polygonLogoImage,
    name: 'Polygon',
    symbol: 'MATIC'
  }
}

// Old chains support: ChainId.BSC, ChainId.POLYGON
export const SUPPORTED_CHAINS =
  process.env.REACT_APP_ENV === 'production' ? [ChainId.ETHEREUM] : [ChainId.ETHEREUM]

export const TOKEN_MAP: Record<ChainId, Token[]> = {
  [ChainId.ETHEREUM]: [],
  [ChainId.BSC]: [...BSC_TOKENS],
  [ChainId.POLYGON]: [...POLYGON_TOKENS]
}

export const DONATION_SGD_AMOUNT_MIN_ALT = 1
export const DONATION_SGD_AMOUNT_MIN = 200
export const DONATION_SGD_AMOUNT_MAX = 20_000

export const GEODE_URL = process.env.REACT_APP_API_URL

// in seconds, 25 mins by default when env var is undefined
export const PAYMENT_EXPIRATION_TIME =
  Number(process.env.REACT_APP_PAYMENT_EXPIRATION_TIME) || 1_500
// in seconds, specific for crypto payment as TripleA expiration time was set to 25 minutes
export const CRYPTO_PAYMENT_EXPIRATION_TIME = 1_500

export const TRANSACTION_ID_RANDOM_LENGTH = 28

export const COUPON_AMOUNT_POLL_INTERVAL = 5_000 // 5 secs, in ms

// Old COUPON token
/*export const COUPON_TOKEN_INFO = {
  address: '0x7f907710d2b609fd673ce75b908edc151c75d57f',
  decimals: 18,
  name: 'Automata TGB Coupon',
  symbol: 'COUP'
}*/
export const COUPON_TOKEN_INFO = {
  address: '0x82Fb462380E526ff6b3bA09aD5D8Dd1907E01330',
  decimals: 18,
  name: 'TimeLimitedToken',
  symbol: 'STAMP'
}

export const ADDRESS_ONE = '0x0000000000000000000000000000000000000001'
